<div>
    <kendo-grid #grid
                [data]="tableGrid.gridData"
                [sortable]="true"
                [sort]="tableGrid.gridSort"
                (sortChange)="tableGrid.sortChange($event)"
                [rowHeight]="tableGrid.options.rowHeight"
                [loading]="isLoading"
                [height]="rowHt - 70"
                [scrollable]="'virtual'">
        <kendo-grid-column title="Journey" field="od" [width]="90" [class]="'no-wrap'" [headerClass]="'ra-grid-header'"></kendo-grid-column>
        <kendo-grid-column title="Class" field="passengerClass" [width]="65" [class]="'class-name'" [headerClass]="'ra-grid-header'"></kendo-grid-column>
        <kendo-grid-column title="Type" field="journeyType" [headerClass]="'ra-grid-header'"></kendo-grid-column>
        <kendo-grid-column title="AP Bkt" field="apBucket" [headerClass]="'ra-grid-header'"></kendo-grid-column>
        <kendo-grid-column title="AP Fare" field="apFare" format="{0:n2}"
                           [headerClass]="['ra-grid-header', 'col-pull-right']"
                           [class]="'col-pull-right'"></kendo-grid-column>
        <kendo-grid-column title="Flex Bkt" field="flexBucket" [headerClass]="'ra-grid-header'"></kendo-grid-column>
        <kendo-grid-column title="Flex Fare" field="flexFare" format="{0:n2}"
                           [headerClass]="['ra-grid-header', 'col-pull-right']"
                           [class]="'col-pull-right'"></kendo-grid-column>
        <kendo-grid-column title="Diff" field="fareDiff" format="{0:n2}"
                           [headerClass]="['ra-grid-header', 'col-pull-right']"
                           [class]="'col-pull-right'"></kendo-grid-column>
        <kendo-grid-column title="From" field="effStartDate" format="{0:d}" [width]="80" [headerClass]="'ra-grid-header'"></kendo-grid-column>
        <kendo-grid-column title="To" field="effEndDate" format="{0:d}" [width]="80" [headerClass]="'ra-grid-header'"></kendo-grid-column>
        <!-- Exports every row (not just the rendered ones) in the current sort order, with full column names -->
        <kendo-grid-excel [fileName]="exportFileName()">
            <kendo-excelexport-column field="origin" title="Origin"></kendo-excelexport-column>
            <kendo-excelexport-column field="destination" title="Destination"></kendo-excelexport-column>
            <kendo-excelexport-column field="passengerClass" title="Class"></kendo-excelexport-column>
            <kendo-excelexport-column field="journeyType" title="Journey Type"></kendo-excelexport-column>
            <kendo-excelexport-column field="apBucket" title="AP Bucket"></kendo-excelexport-column>
            <kendo-excelexport-column field="apFare" title="AP Fare" [cellOptions]="moneyCell"></kendo-excelexport-column>
            <kendo-excelexport-column field="flexBucket" title="Flex Bucket"></kendo-excelexport-column>
            <kendo-excelexport-column field="flexFare" title="Flex Fare" [cellOptions]="moneyCell"></kendo-excelexport-column>
            <kendo-excelexport-column field="fareDiff" title="Fare Difference" [cellOptions]="moneyCell"></kendo-excelexport-column>
            <kendo-excelexport-column field="effStartDate" title="Effective From" [cellOptions]="dateCell"></kendo-excelexport-column>
            <kendo-excelexport-column field="effEndDate" title="Effective To" [cellOptions]="dateCell"></kendo-excelexport-column>
        </kendo-grid-excel>
    </kendo-grid>
</div>
